// eslint-disable-next-line max-len
import FiltersRefinementContent from './FiltersRefinement/SubComponents/FiltersRefinementContent';
import {EFiltersRefinement} from './FiltersRefinement/IFiltersRefinement';

/**
 * Returns selected refinements
 * @param {refinement} refinement - refinements
 * @param {Object} selectedRefinements - refinements
 * @returns {number} number of selected refinements
 */
export function getRightActiveRefinements(isTitle, selectedRefinements, refinement) {
	let res: number = 0;

	if (selectedRefinements && refinement && selectedRefinements){
		let splitRef = selectedRefinements;

		if (refinement?.attributeId !== 'c_categoryFilter'){
			res = splitRef.length;
		} else {
			let secSplitRef = splitRef.map((el) => el?.split(' > '));
			let counter = 0;

			for (let el of secSplitRef) {
				const index = el.findIndex((el) => el === refinement.label);

				if ( index !== -1 ) {
					counter++;
				}
			}

			res = isTitle ? splitRef.length : counter;
		}
	}

	return res;
}

/**
 * Returns the right refinement attribute component
 * @param attributeId - refinement attribute id
 * @returns {React.ReactNode} the refinement attribute component
*/
export function getRefinementComponent(attributeId) {
	let Component = FiltersRefinementContent.Text;

	if (
		attributeId === EFiltersRefinement.SIZE
	) {
		Component = FiltersRefinementContent.Checkbox;
	}

	if (
		attributeId === EFiltersRefinement.COLORDATA
	) {
		Component = FiltersRefinementContent.ColorData;
	}

	return Component;
}